module.exports = __webpack_public_path__ + "static/media/harri.67b32947.jpg";